import ACTION_NAMES from "actions/ACTION_NAMES";
import { generateReadActionCreator } from "actions/crudActionCreators";
import routes from "actions/routes";

export default {
    readAll: generateReadActionCreator(routes.API_INVOICE_REPORT, ACTION_NAMES.INVOICE_REPORT)
}
